import { createAsyncThunk } from "@reduxjs/toolkit";
import { LanguageService } from "../../../services/LanguageService";
import { AxiosError } from "axios";
import { OperationalLanguageInterface } from "../../../entities/Language";

export const fetchOperationalLanguages = createAsyncThunk<
  OperationalLanguageInterface[],
  any,
  { rejectValue: AxiosError }
>("language/fetchOperationalLanguages", async (_, { rejectWithValue }) => {
  try {
    const response = await LanguageService.getOperationalLanguages();
    return response;
  } catch (e: any) {
    return rejectWithValue(e.message as AxiosError);
  }
});
